const firebaseConfig = {
    apiKey: "AIzaSyDAw8JztO91KDcde-r3r5_nzv-uCkSttmE",
    authDomain: "cryptox-6bc97.firebaseapp.com",
    projectId: "cryptox-6bc97",
    storageBucket: "cryptox-6bc97.appspot.com",
    messagingSenderId: "4261936918",
    appId: "1:4261936918:web:8d6944cfc33b2d9cca9a37"
  };


  export default firebaseConfig;